import { aludraApi } from 'Api/axios'

const mdl22 = {
  searchTypeList: 'mdl22/products/productCustomList/searchTypeList',
  productCustomList: 'mdl22/products/productCustomList',
  addUpdate:
    'mdl22/products/productCustomList/addUpdateProductCustomListQuantity',
}

const mdl04 = {
  productCustomList: 'mdl04/productCustomList',
  searchProducts: 'mdl04/SearchProducts/AdminPortal',
}

export const searchQuickListSettingsService = payload => {
  return aludraApi.post(mdl22.searchTypeList, payload)
}

export const getQuickListSettingService = productCustomListId => {
  return aludraApi.get(mdl22.productCustomList, {
    params: { productCustomListId },
  })
}

export const saveQuickListSettingService = payload => {
  return aludraApi.post(mdl22.addUpdate, payload)
}

export const deleteQuickListSettingService = productCustomListId => {
  return aludraApi.delete(mdl04.productCustomList, {
    data: { ProductCustomListId: productCustomListId },
  })
}

export const searchAdminProductsService = payload => {
  return aludraApi.post(mdl04.searchProducts, payload)
}
